module.exports = __webpack_public_path__ + "img/nemotron-hebrew-perf.f291ce3b.png";